export const ReactToastifyPosition = 'bottom-right';
